/*
    Shipping in Cart
*/

document.addEventListener('DOMContentLoaded', getCart);

// handles the "Geschenkoptionen"-shipping-section visibility
document.addEventListener('onQuantityChange', getCart);

function checkProps() {
    // stop checking if all items have a _taxAmount property
    if (window.stopChecking === true) window.clearInterval(repeatedCheck);

    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(res => res.json())
        .then(cart => {
            const itemsMissingProperty = cart.items.filter(item => !item.properties._taxAmount);
            if (itemsMissingProperty.length === 0) {
                window.stopChecking = true;
                return;
            }
            itemsMissingProperty.forEach(item => addTaxPropertyToLineItem(item));
        })
        .catch(err => console.error(err));
}

function getCart() {
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(res => res.json())
        .then(cart => {
            removeUpgradeOptions(cart);
            cart.items.forEach(item => addTaxPropertyToLineItem(item));
            return cart;
        })
        .then(cart => handleCartLoad(cart))
        .catch(err => console.error(err));
};

const handleCartLoad = function (cart) {
    const settings = getShippingData();
    const productTypes = settings.general['shipping_methods'];
    const pictureIds = [...document.querySelectorAll('[data-picture-id]')].map(elem => parseInt(elem.dataset.productId));
    const packagingSettingItemIds = settings.products.map(product => product.variantId);
    const $continueButtons = [...document.querySelectorAll('#checkout, .btn-punchout-transfer')];
    if (!$continueButtons.length) return;

    const packingItemsInCart = cart.items.filter(item => packagingSettingItemIds.includes(item.id));
    const hiddenItemsInCart = cart.items.filter(item => item.product_type === 'PPLR_HIDDEN_PRODUCT').length;
    const tankingOptionCount = cart.items.reduce((prev, next) => next.product_type === 'Tankoption' ? prev + next.quantity : prev, 0);
    const cardPicturesInCart = cart.items.filter(item => pictureIds.includes(item.product_id)).length;
    let packagingCount = 0;
    if (packingItemsInCart.length > 0) {
        packagingCount = packingItemsInCart.length > 1
            ? packingItemsInCart.reduce((prev, next) => prev.quantity + next.quantity)
            : packingItemsInCart[0].quantity;
    }

    // Disable Input Fields for Packaging
    [...document.querySelectorAll('.quantity__input')].forEach(input => {
        if (packagingSettingItemIds.includes(parseInt(input.dataset.variantId))) {
            const plus_button = input.parentElement.querySelector(("button[name='plus']"));
            const minus_button = input.parentElement.querySelector(("button[name='minus']"));
            plus_button.disabled = true;
            minus_button.disabled = true;
            input.disabled = true;
        }
    });

    // Disable Input Fields for picture Items (picture Items can be identified by the data-card-id attribute)
    [...document.querySelectorAll('[data-card-id]')].forEach(elem => {
        elem.querySelector(("button[name='plus']")).disabled = true;
        elem.querySelector(("button[name='minus']")).disabled = true;
        elem.querySelector((".quantity__input")).disabled = true;
    });

    const $shippingSection = document.querySelector('[data-section-shipping]');
    const $selectionHint = document.querySelector('[data-shipping-hint]');

    if (packagingCount === 0) {
        [...document.querySelectorAll('[data-packaging-input]')].forEach(input => input.checked = false);
        $continueButtons.forEach(btn => btn.disabled = true);
        $selectionHint.classList.remove('hidden');
    } else if (packagingCount > 1 || packagingCount === cart.items.length) {
        handleInvalidCart();
    } else if (packagingCount === 1) {
        $continueButtons.forEach(btn => btn.disabled = false);
        $selectionHint.classList.add('hidden');
    }

    const voucherCount = cart.item_count - packagingCount - hiddenItemsInCart - cardPicturesInCart - tankingOptionCount;
    if (voucherCount > 0) {
        productTypes.forEach(type => {
            const product = data.products.filter(product => product.type === type)[0];
            const $productSelect = document.querySelector(`[data-packaging-type="${type}"]`);
            const hasCartOption = packingItemsInCart.length && packingItemsInCart[0].id === product.variantId;

            switch (type) {
                case 'single_upgrade':
                    if (voucherCount !== 1) {
                        removeShippingOption(product.variantId, $productSelect, hasCartOption);
                        break;
                    }
                    showShippingOption($productSelect);
                    break;
                case 'standard_upgrade':
                    if (voucherCount <= 1) {
                        removeShippingOption(product.variantId, $productSelect, hasCartOption);
                        break;
                    }
                    showShippingOption($productSelect);
                    break;
                default:
                    break;
            }
            if (!product.variantId) {
                $productSelect ? $productSelect.remove() : null;
            } else {
                if (!$shippingSection.classList.contains('hidden')) return;
                if ($productSelect) {
                    $productSelect.insertAdjacentHTML('beforeend', `
                        <div ${product.tooltipTitle ? 'class="tooltip" data-tooltip' : 'class="shipping-label"'}>${product.title}
                            ${product.tooltipTitle && (
                            `<div class="tooltip-content">
                                    <img data-src="${product.image}" src="${product.image}" class="lazyload">
                                    <div class="tooltip-text">
                                        <strong>${product.tooltipTitle}</strong>
                                        ${product.tooltipText}
                                    </div>
                                </div>`
                        )}
                        </div>&nbsp;
                        <strong>(+${product.price}${product.shipping ? ' / zzgl. Versand +' + product.shippingLabel : ''})</strong>${product.description ? ' &mdash; ' + product.description : ''}
                    `);
                    const $productInput = $productSelect.querySelector('input');
                    $productInput.dataset.variantId = product.variantId;
                    if (packingItemsInCart.map(item => item.id).includes(product.variantId)) {
                        $productInput.checked = true;
                    }
                }
                document.querySelectorAll('[data-tooltip]').forEach(tooltip => {
                    tooltip.addEventListener('click', e => {
                        e.preventDefault();
                        const openTooltip = e.target;
                        openTooltip.querySelector('.tooltip-content').classList.add('show');
                    });
                });

                document.addEventListener('click', evt => {
                    if (!evt.target.closest('.tooltip')) {
                        [...document.querySelectorAll('.tooltip-content')].forEach(tooltip => tooltip.classList.remove('show'));
                    }
                });
            }
        });
        $shippingSection.classList.remove('hidden');
        initShippingListeners($shippingSection);
    }
};

const initShippingListeners = function (el) {
    const ids = [...el.querySelectorAll('input[data-packaging-input]')].map(i => i.dataset.variantId);
    el.querySelectorAll('input[data-packaging-input]').forEach(input => {
        input.addEventListener('change', e => {
            const data = { updates: {} };
            const packagingToRemove = ids.filter(id => id && id != e.target.dataset.variantId);

            data.updates[e.target.dataset.variantId] = 1;
            packagingToRemove.forEach(id => data.updates[id] = 0);

            updateCart(data);
        });
    });
}

const handleInvalidCart = function () {
    const data = { updates: {} };
    const packagingSettingItemIds = getShippingData().products.map(product => product.variantId);
    packagingSettingItemIds.forEach(id => id ? data.updates[id] = 0 : false);
    updateCart(data);

    const $continueButtons = [...document.querySelectorAll('#checkout, .btn-punchout-transfer')];
    $continueButtons?.forEach(btn => btn.disabled = true);

    const $selectionHint = document.querySelector('[data-shipping-hint]');
    $selectionHint?.classList.remove('hidden');
}

function removeUpgradeOptions(cart) {
    const settings = getShippingData();
    const upgradeOptionsInCart = cart.items.filter(itm => {
        if (settings.general.isUpgraded) {
            return settings.general.standardIds.includes(itm.id) && !settings.general.upgradeIds.includes(itm.id);
        }
        return !settings.general.standardIds.includes(itm.id) && settings.general.upgradeIds.includes(itm.id);
    });
    if (!upgradeOptionsInCart.length) return;

    const data = { updates: {} };
    upgradeOptionsInCart.forEach(option => {
        data.updates[option.variant_id] = 0;
    });
    updateCart(data);
}

const updateCart = function (data) {
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(() => {
            const updateCartButton = document.querySelector("button[name='update']");
            updateCartButton.click();
        })
        .catch(err => console.error(err))
}

function getShippingData() {
    const $shippingSettings = document.querySelector('[data-shipping-settings]');
    try { data = JSON.parse($shippingSettings ? $shippingSettings.textContent : {}); } catch (error) { data = {}; };
    return data;
}

function showShippingOption(elem) {
    elem.closest('div').classList.remove('hidden');
}

function removeShippingOption(variantId, elem, update) {
    elem.closest('div').classList.add('hidden');
    if (!update) return;
    const data = { updates: {} };
    data.updates[variantId] = 0;
    updateCart(data);
}

async function addTaxPropertyToLineItem(item) {
    if (item.properties._taxAmount) return;
    const data = { id: item.key, properties: { ...item.properties, _taxable: item.taxable, _taxAmount: Math.round(item.final_line_price * 0.19) / 100 } };
    await changeCart(data);
}

function changeCart(data) {
    return new Promise((resolve, reject) => {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.text())
            .catch(err => {
                console.error(err);
                reject();
            })
    });
}

const repeatedCheck = window.setInterval(checkProps, 1000);
window.setTimeout(() => window.stopChecking = true, 10000);
